export default {"src":"/_next/static/media/failed-image-icon.78dd31bb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};